// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oLUb","badges":"styles_badges__1yqzO"};